import React from 'react'
import './style.css'
import { updateUser } from '~/redux/user/helpers'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

class UpdateProfile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.args.fields
    }
  }

  render() {
    if (this.state.updateSuccess)
      return (
        <div className="change-password centered padded">
          <h2>{this.state.fields.profileUpdateSuccessMessage}</h2>
        </div>
      )

    return (
      <div className="edit-profile centered padded">
        <h2>{this.state.fields.profilePopupText}</h2>
        <form
          name="updateForm"
          className="update-info-form"
          onSubmit={ e => this.submitForm(e) }>
          <label>{this.state.fields.profilePopupEmail}</label>
          <input
            type="email"
            name="email"
            ref={ e => this.emailInput = e }
            placeholder={this.state.fields.profilePopupEmail}
            defaultValue={this.state.user && this.state.user.email} required/>
          <label>{this.state.fields.profilePopupName}</label>
          <input
            type="text"
            name="name"
            placeholder={this.state.fields.profilePopupName}
            ref={ e => this.nameInput = e }
            defaultValue={this.state.user && this.state.user.name} required/>
          
          <label>{this.state.fields.profilePopupCurrentPassword}</label>
          <input
            type="password"
            name="name"
            placeholder={this.state.fields.profilePopupCurrentPassword}
            ref={ e => this.passwordInput = e }
            required/>
          <br />
          { this.state.error && (<div className="error">{ this.state.error }</div>) }
          <input
            type="submit"
            className={'button cta' + (this.state.processing ? ' processing': '') }
            value={this.state.fields.profilePopupUpdate}/>
        </form>
      </div>
    )
  }

  submitForm(e) {
    e.preventDefault()

    const data = {
      email: this.emailInput.value,
      name: this.nameInput.value,
      password: this.passwordInput.value,
    }
    this.setState({ processing: true })

    updateUser(data)
      .then((response) => {
        this.setState({ updateSuccess: true })
      }).catch(e =>{
        let errorCode = e.response.data.code
        let errorMsg = this.state.fields[errorCode] || this.state.fields.profileUpdateErrorMessage        
        this.displayError(errorMsg)
      }).then( _ => {
        this.setState({ processing: false })
      })
  }

  displayError(e) {
    this.setState({ error: e })
    setTimeout(_ => this.setState({ error: null }), 5000)
  }  
}

connect(UpdateProfile, (state) => ({ user: state.user }), userStore)

export default UpdateProfile;